module.exports = __webpack_public_path__ + "fb76ac2c8cf7e76f50c3f737b2de97be.svg";